import React from 'react';
import { bool, string, func } from 'prop-types';
import { getLinkToSellerPage } from '../../../../utils/getLinkToSellerPage';
import { DOMAIN_SOURCES } from '../../../../constants';

const UserName = ({ withSellerLink = false, username, onSellerLinkClick, refCtxId, contextReferrer }) => {
    const sellerLink = getLinkToSellerPage(username, { source: DOMAIN_SOURCES.CARD, refCtxId, contextReferrer });

    return withSellerLink ? (
        <a className="user" href={sellerLink} target="_blank" onClick={onSellerLinkClick} rel="noreferrer">
            {username}
        </a>
    ) : (
        <span className="user">{username}</span>
    );
};

UserName.propTypes = {
    withSellerLink: bool,
    username: string,
    onSellerLinkClick: func,
    refCtxId: string,
    contextReferrer: string,
};

export default UserName;
